
import Tab from '@/components/elements/Tab.vue'
import HeadingLv1 from '@/components/elements/HeadingLv1.vue'
import MypageContents from '@/components/block/MypageContents.vue'
import EventCardMypage from '@/components/block/EventCardMypage.vue'
import Loader from '@/components/elements/Loader.vue'
import Alert from '@/components/elements/Alert.vue'
import BackTo from '@/components/block/BackTo.vue'
import Button from '@/components/elements/Button.vue'
import { axiosSetting } from '@/utils/axiosSetting'
import { useEvent } from '@/provider/event'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { reactive, defineComponent } from 'vue'
import ModalBase from '@/components/genenral/ModalBase.vue'
import ModalComplete from '@/components/genenral/ModalComplete.vue'
import { mypageTabItems } from '@/utils/commonDataset'

export default defineComponent({
  name: 'EventList',

  components: {
    Tab,
    HeadingLv1,
    MypageContents,
    EventCardMypage,
    Loader,
    Alert,
    BackTo,
    Button,
    ModalBase,
    ModalComplete
  },

  setup() {
    const router = useRouter()
    const store = useStore()
    const state = reactive({
      showConfirmModal: false,
      showCompleteModal: false,
      currentId: '',
      navKey: 0
    })
    const tab = reactive({
      list: mypageTabItems,
      current: 2
    })

    const clickTab = (i: number) => {
      router.push({ path: tab.list[i].link })
    }

    const userInfo = store.state.userInfo
    const getEventHistoryIds = (): number[] => {
      return userInfo.event_history.map(
        (item: { id: string; event_id: string }) => parseInt(item.event_id)
      )
    }

    const { reservedEvents, loadEventsFromHistoryIds, loading } = useEvent()
    loadEventsFromHistoryIds(100, getEventHistoryIds())

    const clickCancel = (id: string) => {
      state.showConfirmModal = true
      state.currentId = id
    }

    const cancelEvent = () => {
      store.commit('showLoading')
      const ajax = axiosSetting('app', 'action')

      ajax
        .post('/api/v1/event_cancel', {
          event_id: state.currentId
        })
        .then(() => {
          state.showConfirmModal = false
          state.showCompleteModal = true
          userInfo.event_history.splice(
            userInfo.event_history.findIndex(
              (item: { id: string; event_id: string }) =>
                item.event_id == state.currentId
            ),
            1
          )

          state.navKey++
          loadEventsFromHistoryIds(100, getEventHistoryIds())
        })
        .catch((err) => {
          try {
            if (err.response.status === 422) {
              const errors = err.response.data.err_msg

              Object.keys(errors).forEach((key: string) => {
                alert(errors[key][0])
              })
              return
            }

            store.commit('showSystemError', 'modal')
          } catch (e) {
            store.commit('showSystemError', 'modal')
          }
        })
        .then(() => {
          store.commit('closeLoading')
        })
    }

    return {
      state,
      tab,
      clickTab,
      loading,
      reservedEvents,
      clickCancel,
      cancelEvent
    }
  }
})
